import { useContext, useEffect, useState } from 'react'
import { FPS } from 'site/creation-tools/constants'
import { CreationSourceEditorContext } from '../manager'

const usePlayheadTime = () => {
    const { previewPlayheadTime } = useContext(CreationSourceEditorContext)
    const [currentPlayheadTime, setCurrentPlayheadTime] = useState<number>(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentPlayheadTime(previewPlayheadTime.current)
        }, 1000 / FPS)

        return () => {
            clearInterval(interval)
        }
    }, [])

    return {
        currentPlayheadTime,
    }
}

export default usePlayheadTime
